import enrolLoyaltyAccount from 'actions/loyalty/enrolLoyaltyAccount'
import { useAppDispatch } from 'hooks/reduxHooks'
import React, { useCallback } from 'react'
import LoyaltyLandingPageUSPSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageUSPSection'
import LoyaltyLandingPageHowItWorksSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageHowItWorksSection'
import useLoyaltyUserEligibilityTier from 'loyalty/hooks/useLoyaltyUserEligibilityTier'
import LoyaltyUserBronzeHero from './LoyaltyUserBronzeHero'
import LoyaltyUserSilverHero from './LoyaltyUserSilverHero'
import LoyaltyUserGoldHero from './LoyaltyUserGoldHero'
import LoyaltyLandingPageBenefitsTableSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageBenefitsTableSection'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import LoyaltyLandingPageDiscoverTiersSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageDiscoverTiersSection'
import LoyaltyLandingPageFaqSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageFaqSection'
import LoyaltyUserBronzeBenefits from '../loyaltyLandingPageSharedSections/LoyaltyUserBronzeBenefits'
import LoyaltyUserGoldBenefits from '../loyaltyLandingPageSharedSections/LoyaltyUserGoldBenefits'
import LoyaltyUserSilverBenefits from '../loyaltyLandingPageSharedSections/LoyaltyUserSilverBenefits'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'

function LoyaltyGuestLandingPage() {
  const dispatch = useAppDispatch()
  const [eligabilityTier, fetchingEligability] = useLoyaltyUserEligibilityTier()

  const onJoinClick = useCallback(() => {
    dispatch(enrolLoyaltyAccount({ enrolment: 'existingUserRegistration' }))
  }, [dispatch])

  if (fetchingEligability) {
    return <LoadingIndicator />
  }

  return <div>
    {eligabilityTier === 'bronze' && <LoyaltyUserBronzeHero onActivate={onJoinClick} />}
    {eligabilityTier === 'silver' && <LoyaltyUserSilverHero onActivate={onJoinClick} />}
    {eligabilityTier === 'gold' && <LoyaltyUserGoldHero onActivate={onJoinClick} />}
    <LoyaltyLandingPageUSPSection />
    <Pane type="light-grey">
      <LayoutContainer variant="medium">
        {eligabilityTier === 'bronze' && <LoyaltyUserBronzeBenefits onActivate={onJoinClick} />}
        {eligabilityTier === 'silver' && <LoyaltyUserSilverBenefits onActivate={onJoinClick} />}
        {eligabilityTier === 'gold' && <LoyaltyUserGoldBenefits onActivate={onJoinClick} />}
      </LayoutContainer>
    </Pane>
    <LoyaltyLandingPageDiscoverTiersSection />
    <LoyaltyLandingPageBenefitsTableSection highlightTier={eligabilityTier} onJoin={onJoinClick} />
    <LoyaltyLandingPageHowItWorksSection onJoin={onJoinClick}/>
    <LoyaltyLandingPageFaqSection slug="societe-faqs" />
  </div>
}

export default LoyaltyGuestLandingPage
